import type { BuildReasonCode } from "@heraion/shared";

type T = (key: string, opts?: Record<string, unknown>) => string;

/** What the athlete reads when a program is refused: the code's own key
 *  (program.errCode.<code>), the generic errSchema when the code has none.
 *  Never the English `reason`, which is a log breadcrumb. One wording for the
 *  editor's banner, its problems bar and the model wizard (#400). */
export const buildErrorText = (code: BuildReasonCode, t: T): string =>
  t(`program.errCode.${code}`, { defaultValue: t("program.errSchema") });
